<template>
  <div id="data-view">
    <!-- <ArchivesCard /> -->
    <div class="main-header">
      <TopHeader @onBack="handleBack"></TopHeader>
    </div>
    <div class="main-container">
      <div class="left-chart-container" style="padding-bottom: 0px !important">
        <Left-Chart-2 />
        <Left-Chart-3 />
        <Left-Chart-4 />
      </div>

      <div class="right-main-container">
        <div class="rmc-top-container">
          <div class="rmctc-left-container">
            <Center-Cmp ref="mapRefs" />
            <div>
              <Bottom-Charts />
            </div>
          </div>
          <div class="rmctc-right-container">
            <!-- <dv-border-box-6 :color="[$color.borderColor, $color.borderColor]"> -->
            <div class="right-container">
              <Right-Chart-2 />
              <Right-Table-3 />
            </div>
            <!-- </dv-border-box-6> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftChart1 from "./LeftChart1";
import LeftChart2 from "./LeftChart2";
import LeftChart3 from "./LeftChart3";
import LeftChart4 from "./LeftChart4.vue";
import CenterCmp from "./CenterCmp";

// import RightChart1 from "./RightChart1";
import RightChart2 from "./RightChart2";

import BottomCharts from "./BottomCharts";
import RightChart1 from "./RightChart1.vue";
import RightTable3 from "./RightTable3.vue";
import TopHeader from "./TopHeader.vue";

import ArchivesCard from "./ArchivesCard.vue";
import { mapMutations } from "vuex";
import { formatConfig } from "../../utils/index";
export default {
  name: "DataView",
  components: {
    LeftChart1,
    LeftChart2,
    LeftChart3,
    LeftChart4,
    CenterCmp,
    RightChart1,
    RightChart2,
    BottomCharts,
    RightTable3,
    TopHeader,
    ArchivesCard,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapMutations(["SET_GLOBALDATA"]),
    handleBack() {
      this.$refs.mapRefs.onBack();
    },
    initData() {
      // this.$store.dispatch("app/toggleSideBar");

      this.$store.dispatch("app/getGlobalData", { key: "" });
      // this.$store.dispatch("app/getToken");
      // this.$store.dispatch("app/getVisitUsers");
    },
  },
  mounted() {
    if (this.$route.query.channel) {
      this.$store.commit("login/SET_CHANNEL_ACCOUT", this.$route.query.channel);
    }
    // formatConfig();
    this.initData();
  },
};
</script>

<style lang="less">
// @background-color: #fae1b0;

#data-view {
  width: 100%;
  height: 100%;
  // background-color: #030409;
  // color: #abd1e7;
  background-image: url("./img/bg.png");
  color: @primary-color;
  // background: @background-color;
  background-size: 100% 100%;
  // background: linear-gradient(95deg, #abd1e7, #abd1e7);
  box-shadow: -4px -3px 4px 0px rgba(4, 54, 151, 0.67);
  padding: 10px;
  .main-container {
    // height: calc(~"1080 - 100px");
    height: calc(~"100% - 80px");
    // padding: 0 10px;
    padding-bottom: 100px !important;
    display: flex;
    margin: 20px 0;
    // background: @background-color;
    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-chart-container {
    // background: #fff;
    margin-right: 10px;
    width: 25%;
    // padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px !important;

    .border-box-content {
      flex-direction: column;
      padding-bottom: 0px;
    }
  }
  // .left-chart-container-box {
  //   .border-box-content {
  //     padding-bottom: 0px;
  //   }
  // }

  .right-main-container {
    width: 78%;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .rmc-top-container {
    height: 100%;
    display: flex;
    // flex-direction: column;
  }

  .rmctc-left-container {
    width: 65%;
    display: flex;
    flex-direction: column;
  }

  .rmctc-right-container {
    padding-left: 10px;
    margin-left: 10px;
    width: 35%;
    height: 100%;
    .right-container {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .border-box-content {
      padding: 0 20px !important;
    }
  }

  .rmc-bottom-container {
    height: 35%;
  }

  .rmctc-chart-1 {
    height: 30%;
  }
  .rmctc-chart-2 {
    height: 70%;
  }
}
</style>
